"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameplayTextBubble = void 0;
const tslib_1 = require("tslib");
const phaser_1 = tslib_1.__importDefault(require("phaser"));
const consts_1 = require("../consts");
const TextBubbleChoiceFull_1 = require("./TextBubble/TextBubbleChoiceFull");
const TextBubbleBase_1 = require("./TextBubble/TextBubbleBase");
class GameplayTextBubble extends phaser_1.default.GameObjects.Container {
    /**
     * Create Text Bubble
     */
    constructor(scene, getDevicePixelRatio, stylesAlias, isMultiplayer) {
        super(scene);
        this.textBubblesObjectPoolArr = [];
        this.gameplayScene = scene;
        this.currentType = consts_1.STORY_STATE.Dialogue;
        this.currentText = '';
        this.currentSide = consts_1.SIDE.RIGHT;
        this.characterName = '';
        this.isAssetsLoaded = false;
        this.isAssetsLoading = false;
        this.imagesList = {};
        // store latest type to check if type is change to decide if show animations
        this.latestType = undefined;
        this.textBubble = undefined;
        this.boundsInterval = undefined;
        this._stylesAlias = stylesAlias;
        this._isMultiplayer = isMultiplayer;
        this._getDevicePixelRatio = getDevicePixelRatio;
    }
    destroy() {
        this.clearBoundsInterval();
        super.destroy();
    }
    /**
     * Display bubble by type
     */
    display(props) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { type, text, side, characterName, isRawText, isAnimated, isVisibleText } = props;
            if (this.textBubble) {
                yield this.hide();
            }
            this.props = props;
            this.currentType = type;
            this.currentText = text;
            this.currentSide = side || consts_1.SIDE.LEFT;
            this.characterName = characterName;
            if (!this.characterName) {
                this.characterName = '';
            }
            // MICHAL NOTE: not fully implemented, don't know if used at all
            this.darkMode = false;
            this.textBubble = this.getTextBubbleByType(this.currentType);
            this.textBubble.setIsRawText(isRawText);
            this.textBubble.setIsAnimated(isAnimated);
            this.textBubble.setIsVisibleText(isVisibleText);
            this.textBubble.setBubbleType(this.currentType);
            if (this.currentType === consts_1.STORY_STATE.Choice) {
                // which type is this.textBubble?
                this.textBubble.init(props);
            }
            else {
                // which type is this.textBubble?
                this.textBubble.init(this.currentText, this.currentSide, this.characterName);
            }
            // if (this.latestType !== type && typeof this.textBubble.animateMe === 'function') {
            //     this.textBubble.animateMe();
            // }
            this.latestType = type;
        });
    }
    /**
     * Hide current bubble
     */
    hide() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => {
                if (this.textBubble) {
                    this.textBubble.uninit();
                    resolve();
                }
            });
        });
    }
    updateStylesAlias(stylesAlias) {
        var _a;
        this._stylesAlias = stylesAlias;
        (_a = this.textBubble) === null || _a === void 0 ? void 0 : _a.updateStylesAlias(stylesAlias);
    }
    updateBubbleData(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // check if types are matching
            if (data.type !== this.currentType) {
                return;
            }
            if (data.type === consts_1.STORY_STATE.Choice) {
                yield this.updateChoiceButtons(data);
            }
        });
    }
    updateBubbleTextOnly(text) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => {
                var _a;
                (_a = this.textBubble) === null || _a === void 0 ? void 0 : _a.updateText(text);
                resolve();
            });
        });
    }
    updateChoiceButtonsTextOnly(texts) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => {
                if (this.currentType === consts_1.STORY_STATE.Choice) {
                    this.textBubble.updateChoiceTexts(texts);
                }
                resolve();
            });
        });
    }
    updateChoiceButtonsAnalytics(analyticStep) {
        if (this.currentType === consts_1.STORY_STATE.Choice) {
            this.textBubble.updateChoiceAnalytics(analyticStep);
        }
    }
    updateChoiceButtonsAnalyticsViewType(viewType) {
        if (this.currentType === consts_1.STORY_STATE.Choice) {
            this.textBubble.updateChoiceAnalyticsViewType(viewType);
        }
    }
    hideChoiceButtonsAnalytics() {
        if (this.currentType === consts_1.STORY_STATE.Choice) {
            this.textBubble.hideChoiceAnalytics();
        }
    }
    updateChoiceButtons(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const textBubble = this.textBubble;
            switch (data.updateType) {
                case consts_1.UPDATE_TYPE.ANSWER_DATA:
                    // make copy to not mutate oryginal array
                    const answers = data.answers ? [...data.answers] : [];
                    textBubble.setAnswersSettings(data.settings);
                    textBubble.setAnswers(answers);
                    return;
                case consts_1.UPDATE_TYPE.ANSWER_SELECT:
                    textBubble.setSelectAnswer(data.answerNum);
                    return;
                case consts_1.UPDATE_TYPE.DISABLE_BUTTONS:
                    textBubble.setDisableButtons();
                    return;
                case consts_1.UPDATE_TYPE.VOTES_EXTRAS:
                    textBubble.setVotesExtras(data.votesData);
                    return;
            }
        });
    }
    /**
     * Gets full data with boundaries of all elements
     */
    getBoundsData() {
        if (!this.textBubble) {
            return false;
        }
        this.textBubble.calcElementsBoundsData();
        let textBubbleBounds = this.textBubble.getElementBoundsData();
        // check choices boundaries if needed
        let chocieButtonsBoundsArr = false;
        if (this.currentType === consts_1.STORY_STATE.Choice) {
            chocieButtonsBoundsArr = this.textBubble.getChoicesBoundsData();
        }
        return {
            textBubbleBounds,
            choiceButtonsBounds: chocieButtonsBoundsArr
        };
    }
    clearBoundsInterval() {
        if (this.boundsInterval) {
            clearInterval(this.boundsInterval);
            this.boundsInterval = undefined;
        }
    }
    getTextBubbleByType(type) {
        let existingBubbleObj = this.textBubblesObjectPoolArr[type];
        if (!existingBubbleObj) {
            existingBubbleObj = this.getNewTextBubbleInstanceByType(type);
            this.textBubblesObjectPoolArr[type] = existingBubbleObj;
        }
        return existingBubbleObj;
    }
    getNewTextBubbleInstanceByType(type) {
        const dPRCallback = this._getDevicePixelRatio;
        switch (type) {
            case consts_1.STORY_STATE.Choice:
                return new TextBubbleChoiceFull_1.TextBubbleChoiceFull(this.gameplayScene, this.imagesList, dPRCallback, this._stylesAlias, this._isMultiplayer, this);
            case consts_1.STORY_STATE.Dialogue:
            case consts_1.STORY_STATE.Text:
            case consts_1.STORY_STATE.Ending:
            case consts_1.STORY_STATE.Texting:
            case consts_1.STORY_STATE.Thinking:
            default:
                return new TextBubbleBase_1.TextBubbleBase(this.gameplayScene, this.imagesList, dPRCallback, this._stylesAlias, this._isMultiplayer, this);
        }
    }
}
exports.GameplayTextBubble = GameplayTextBubble;
